import React from 'react';
import styled, { css } from 'styled-components';

import { NewDatePickerProps } from '../../NewDatePicker';
import CoreDatePicker from '../../../_common/CoreDatePicker/CoreDatePicker';
import { CalendarClickableAffix } from '../../../_common/CoreDatePicker/Calendar/styles';
import Controller from '../../../_common/Controller';
import Outline from '../../../_common/Outline/Outline';

import NewInput from '../../../NewInput/NewInput';
import Calendar from '../NewDatePickerCalendar/NewDatePickerCalendar';

import { controllerTokens } from '../../../../tokens/components/Controller/tokens';

const StyledDatePicker = styled(CoreDatePicker)`
  position: static;

  ${CalendarClickableAffix} {
    border-radius: ${Controller.styles.borderRadius};
    border: ${Controller.styles.borders.default};
    box-shadow: none;
    height: 34px;
    margin: 3px;
    padding: 8px;

    &:focus-visible {
      border-color: ${controllerTokens.ContainerBorderColorBaseKeyboardFocus};
      box-shadow: 0 0 0 ${controllerTokens.ContainerShadowWidthBaseKeyboardFocus}
        ${controllerTokens.ContainerShadowColorBaseKeyboardFocus};
    }

    ${({ invalid }) =>
      invalid &&
      css`
        &:focus-visible {
          border-color: ${controllerTokens.ContainerBorderColorInvalidDefault};
          box-shadow: 0 0 0 ${controllerTokens.ContainerShadowWidthInvalidKeyboardFocus}
            ${controllerTokens.ContainerShadowColorInvalidKeyboardFocus};
        }
      `}

    ${({ disabled }) =>
      !disabled &&
      css`
        &:hover {
          border: ${Controller.styles.borders.hover};
        }
      `}
  }

  ${Outline} {
    &::after {
      content: none; /* Disables the Outline Triangle */
    }
  }
`;

function TableDatePicker(props: NewDatePickerProps) {
  const { className, style, ...otherProps } = props;

  return <StyledDatePicker {...otherProps} width="full" align="right" />;
}

TableDatePicker.defaultProps = {
  width: 'half',
  disabled: false,
  input: props => <NewInput {...props} />,
  calendar: props => <Calendar {...props} />,
  shortcuts: undefined,
  align: 'right',
};

export default TableDatePicker;
